
const inputTextLimit = 250;
const inputDescLimit = 10000;

export { inputTextLimit, inputDescLimit };  